import { LDate } from '@app/components/date/LDate';
import { Seconds } from '@mi-front/core';
import { Chip, Duration, MrtTable } from '@mi-front/ui';
import { useIntl } from 'react-intl';
import { LTime } from '../../../../components/date/LTime';
import { RowActions } from '../../../../components/table/RowActions';
import { ListingResultProps } from '../../../../core/reports/components/ListingView';
import { useActiveStation } from '../../../../core/stations/hooks/useActiveStation';
import { AuditMediaPlayerAction } from '../../components/AuditMediaPlayerAction';
import { DownloadAudioBtn } from '../../components/download-audio/DownloadAudioBtn';
import { AudiosListing } from './AudiosListView';

export function AudiosListResult(p: ListingResultProps<AudiosListing>) {
  const { $t } = useIntl();
  const station = useActiveStation();

  return (
    <MrtTable
      {...p.mrtProps}
      columns={[
        {
          header: $t({
            id: 'audit.audiosScreen.props.date',
            defaultMessage: 'Fecha de carga',
          }),
          accessorKey: 'createdAt',
          Cell: ({ row }) => (
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <LDate value={row.original.createdAt} day="2-digit" month="2-digit" year="2-digit" />
              <LTime value={row.original.createdAt} />
            </div>
          ),
          size: 200,
        },
        {
          header: $t({
            id: 'audit.audiosScreen.props.audioId',
            defaultMessage: 'Archivo ID',
          }),
          accessorKey: 'customId',
          Cell: ({ row }) => (
            <span>
              {row.original.customId}{' '}
              {row.original.stationsGroupId && (
                <Chip size="sm" type="light">
                  {$t({
                    id: 'audit.audiosScreen.group',
                    defaultMessage: 'Group',
                  })}
                </Chip>
              )}
            </span>
          ),
          size: 250,
        },
        {
          header: $t({
            id: 'audit.audiosScreen.props.filename',
            defaultMessage: 'Archivo',
          }),
          accessorKey: 'filename',
          size: 200,
        },
        {
          header: $t({
            id: 'audit.audiosScreen.props.duration',
            defaultMessage: 'Duración',
          }),
          accessorKey: 'duration',
          Cell: ({ row }) => <Duration seconds={(row.original.duration / 1000) as Seconds} />,
          size: 100,
        },
        {
          header: $t({
            id: 'common.text.actions',
            defaultMessage: 'Acciones',
          }),
          Cell: ({ row }) => (
            <RowActions>
              <DownloadAudioBtn
                size="small"
                stationId={station.id}
                audioId={row.original.customId}
              />
              <AuditMediaPlayerAction
                audio={{
                  ...row.original,
                  stationId: station.id,
                }}
              />
            </RowActions>
          ),
        },
      ]}
    />
  );
}
